module.exports = __webpack_public_path__ + "img/nav-vehicle-models-homepage-infiniti.5150a8c8.png";